import { Popup } from './Popup';

export function Tooltip({ className = '', text, children }: React.PropsWithChildren<{ text: string; className?: string }>) {
    return (
        <Popup content={<div className={'p-[8px] whitespace-nowrap mt-[5px] text-ash-grey bg-night-black rounded-[4px] ' + className}>{text}</div>}>
            {children}
        </Popup>
    );
}
